DO.Subscribe(['app:ready'], () => {
  const accordionSelector = '[data-accordion]';

  // Use carbon config to find dom elements
  const config = {
    selectorInit: '[data-accordion]',
    selectorAccordionItem: '[data-accordion-item]',
    selectorAccordionContent: '.accordion__content',
    classActive: 'accordion__item--active',
    selectorAccordionItemHeading: '[data-accordion-trigger]',
  };

  // Callback function to execute when mutations are observed
  const callback = (mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.oldValue === 'true') {
      // do nothing is accordion is closing
        return;
      }

      const { target } = mutation;
      const accordion = target.closest(accordionSelector);

      accordion
        .querySelectorAll(
          `${config.selectorAccordionItem}.${
            config.classActive
          }:not([aria-controls="${target.getAttribute('aria-controls')}"])`,
        )
        .forEach((item) => {
          const trigger = item.querySelector(config.selectorAccordionItemHeading);
          if (
            trigger
          && trigger.getAttribute('aria-controls')
            !== target.getAttribute('aria-controls')
          ) {
            item.classList.remove(config.classActive);
            item
              .querySelector(config.selectorAccordionItemHeading)
              .setAttribute('aria-expanded', 'false');
          }
        });

    // Scroll accordion heading to top
    // target.scrollIntoView({ behavior: 'smooth' });
    });
  };

  const observer = new MutationObserver(callback);

  function AccordionAutoCollapse() {
  // Each accordion with the data-accordion set to tru is a candidate
    document.querySelectorAll(accordionSelector).forEach((el) => {
    // Start observing the entire accordion for change of the aria attribute
      observer.observe(el, {
        attributeFilter: ['aria-expanded'],
        attributeOldValue: true,
        subtree: true,
      });
    });
  }

  if (document.querySelector(accordionSelector)) AccordionAutoCollapse();

  const triggerSelector = '[data-accordion] [aria-expanded]';

  const initToggle = (button, key) => {
    function doToggle(target) {
      if (button.getAttribute('aria-expanded') === 'true') {
        button.setAttribute('aria-expanded', 'false');
        document.querySelector('.menu-nav').classList.remove('accordion--open');
        button.closest(config.selectorAccordionItem).classList.remove(config.classActive);
      // eslint-disable-next-line no-param-reassign
      // target.style.display = 'none';
      } else {
        button.setAttribute('aria-expanded', 'true');
        document.querySelector('.menu-nav').classList.add('accordion--open');
        button.closest(config.selectorAccordionItem).classList.add(config.classActive);
      // eslint-disable-next-line no-param-reassign
      // target.style.display = 'block';
      }
    }

    button.addEventListener('click', (e) => {
      if (button.getAttribute('aria-expanded') === 'false') {
        e.preventDefault();
        doToggle(document.getElementById(button.getAttribute('aria-controls')));
      } else if (e.target.tagName !== 'A') {
        doToggle(document.getElementById(button.getAttribute('aria-controls')));
      }
    });
  };

  document.querySelectorAll(triggerSelector).forEach((el, key) => initToggle(el, key));

  // set vh height css var
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  // We listen to the resize event
  window.addEventListener('resize', () => {
  // We execute the same script as before
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
});
